/* ------------------------------------------ GRYFF COUNT DOWN - T 03.08.2018 ----------------------------------------- */
import utils from '@/app/utils/gfUtils';
import smartEvergreen from './smartEvergreen.ts';

(function (jQuery) {
  jQuery.gfDatePicker = function (element, options) {
    const defaults = {
      title: '',
      type: 'default',
      addHistory: true,
      onSelected: function (value) {},
      onOpacity: function () {},
      offOpacity: function () {},
      onHistoryAdded: function () {},
    };
    this.settings = {};
    const $element = jQuery(element);
    const _this = this;

    const _valueChanged = false;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();

      if ($element.attr('name') == 'datetime') {
        _this.datetime();
      } else if ($element.attr('name') == 'dateDaily') {
        _this.dateDaily();
      } else if ($element.attr('name') == 'dateEvergreen') {
        _this.dateEvergreen();
      }
    };

    this.datetime = function () {
      if ($element.attr('value') == '2010/12/31 00:00:00') {
        const d = new Date();
        d.setDate(d.getDate() + 8);

        const dformat =
          [d.getFullYear(), d.getMonth() + 1, d.getDate()].join('/') +
          ' ' +
          [d.getHours(), d.getMinutes(), d.getSeconds()].join(':');
        $element.attr('value', dformat).val(dformat);
      }
      const _mdDatetimePicker = '<div id="md-datetime-picker"></div>';
      const _content =
        '<div class="md-content"> <div class="md-modal-handle gf_modal-draggable"> <span class="md-title">Date time picker<span></span></span> </div> <div class="md-body"> <input type="text" name="datetime" id="datetime"/> </div></div>';

      $element.gfInputField({
        title: _this.settings.title,
      });
      // Cache input elêmnet data picker;
      const $inputDatePicker = $element.next().find('input');
      $element.next().addClass('datetime');
      $inputDatePicker.off('click').on('click', function () {
        let _template = '<div class="gfDatePickerPopup">';
        _template += '<div class="datetime"></div>';
        _template += '</div>';

        const $popup = jQuery(_template);

        const $dad = $element.closest('.gfSettingGroup');
        $dad.css({
          'z-index': '30',
        });
        _this.settings.onOpacity();
        $dad.after($popup);

        $popup.find('.datetime').datetimepicker({
          viewMode: 'YMDHMS',
          date: new Date($element.attr('value')),
          onClose: function () {
            $popup.remove();
            _this.settings.offOpacity();
          },
          onOk: function () {
            const time = this.getText();
            $element
              .attr('value', time)
              .val(time)
              .trigger('input-change')
              .trigger('value-change')
              .trigger('history-change');
            $popup.remove();
            _this.settings.offOpacity();
          },
        });

        let top = $inputDatePicker.offset().top;
        if (top + $popup.height() + 80 > $(window).height()) {
          top = top + $popup.height() + 50;
          const srcollTop = top - $(window).height();
          top = $inputDatePicker.offset().top - (srcollTop + 80);
        } else if (top < 0) {
          top = 60;
        } else {
          top = top - 70;
        }
        $popup.css({
          top: top,
        });

        $gfLeftSideBar
          .find('.gfSGBackground')
          .off('mousedown.picker')
          .on('mousedown.picker', function (e) {
            $popup.remove();
          });
      });
    };

    this.dateDaily = function () {
      const dailyDate = {
        hour: '12',
        minute: '35',
        second: '0',
      };
      // 12h, 35m, 20s
      let time = $element.attr('value');
      if (time && time != '') {
        let array = ['1'];
        time = time.toString();
        time = time.toLowerCase();
        if (time.indexOf(',') !== -1) {
          array = time.split(',');
        } else {
          array = [time];
        }
        for (let i = 0; i < array.length; i++) {
          const timer = array[i].trim();
          if (timer.indexOf('h') !== -1) {
            if (!isNaN(parseInt(timer))) {
              dailyDate.hour = parseInt(timer);
            }
          }
          if (timer.indexOf('m') !== -1) {
            if (!isNaN(parseInt(timer))) {
              dailyDate.minute = parseInt(timer);
            }
          }
          if (timer.indexOf('s') !== -1) {
            if (!isNaN(parseInt(timer))) {
              dailyDate.second = parseInt(timer);
            }
          }
        }
      }
      let format = 'AM';
      if (dailyDate.hour == 0) {
        dailyDate.hour = 12;
      } else if (dailyDate.hour == 12) {
        format = 'PM';
        dailyDate.hour = 12;
      } else if (dailyDate.hour > 12) {
        format = 'PM';
        dailyDate.hour = dailyDate.hour - 12;
      }

      const description =
        typeof $element.attr('data-description') !== 'undefined' ? $element.attr('data-description') : '';
      let _template = '<div class="gfDatePicker">';
      _template +=
        '<div class="gfDP_input"><span>Hours</span><input class="hour" value="' + dailyDate.hour + '" /></div>';
      _template +=
        '<div class="gfDP_input"><span>Mins</span><input class="minute" value="' + dailyDate.minute + '" /></div>';
      _template += '<div class="gfDP_input gfDP_switch"><a>' + format + '</a></div>';
      _template += '<div class="gfDesc">' + description + '</div>';
      _template += '</div>';
      const $inputDatePicker = jQuery(_template);
      $element.after($inputDatePicker);

      $inputDatePicker.find('.gfDP_input input').gfInputField({
        addHistory: false,
        onValueChanged: function () {
          const $hour = $inputDatePicker.find('.hour');
          const hour = parseInt($hour.attr('value'));
          if (!isNaN(hour) && hour >= 0 && hour <= 24) {
            // format 24 to 12
            if (format == 'AM') {
              if (hour == 24 || hour == 0) {
                dailyDate.hour = 12;
              } else if (hour > 12 && hour <= 23) {
                format = 'PM';
                dailyDate.hour = hour - 12;
              } else {
                dailyDate.hour = hour;
              }
            } else {
              if (hour == 24 || hour == 0) {
                format = 'AM';
                dailyDate.hour = 12;
              } else if (hour > 12 && hour <= 23) {
                dailyDate.hour = hour - 12;
              } else {
                dailyDate.hour = hour;
              }
            }

            $inputDatePicker.find('.hour').attr('value', dailyDate.hour).val(dailyDate.hour).trigger('value-change');
            $inputDatePicker.find('.gfDP_switch a').text(format);
          }
          const $minute = $inputDatePicker.find('.minute');
          const minute = parseInt($minute.attr('value'));
          if (!isNaN(minute) && minute >= 0 && minute <= 59) {
            dailyDate.minute = minute;
          }

          // format 12 to 24
          if (format == 'PM') {
            if (dailyDate.hour > 0 && dailyDate.hour <= 11) {
              dailyDate.hour = dailyDate.hour + 12;
            }
          }
          if (format == 'AM') {
            if (dailyDate.hour == 12) {
              dailyDate.hour = 0;
            }
          }

          const dformat = dailyDate.hour + 'h, ' + dailyDate.minute + 'm, ' + dailyDate.second + 's';
          $element.attr('value', dformat).val(dformat).trigger('input-change');
        },
        onHistoryAdded: function () {
          $element.trigger('history-change');
        },
      });
      $element.on('value-change', function () {
        let time = $element.attr('value');
        if (time && time != '') {
          let array = ['1'];
          time = time.toString();
          time = time.toLowerCase();
          if (time.indexOf(',') !== -1) {
            array = time.split(',');
          } else {
            array = [time];
          }
          for (let i = 0; i < array.length; i++) {
            const timer = array[i].trim();
            if (timer.indexOf('h') !== -1) {
              if (!isNaN(parseInt(timer))) {
                const hour = parseInt(timer);
                // format 24 to 12
                if (format == 'AM') {
                  if (hour == 24 || hour == 0) {
                    dailyDate.hour = 12;
                  } else if (hour > 12 && hour <= 23) {
                    format = 'PM';
                    dailyDate.hour = hour - 12;
                  } else {
                    dailyDate.hour = hour;
                  }
                } else {
                  if (hour == 24 || hour == 0) {
                    format = 'AM';
                    dailyDate.hour = 12;
                  } else if (hour > 12 && hour <= 23) {
                    dailyDate.hour = hour - 12;
                  } else {
                    dailyDate.hour = hour;
                  }
                }

                $inputDatePicker
                  .find('.hour')
                  .attr('value', dailyDate.hour)
                  .val(dailyDate.hour)
                  .trigger('value-change');
                $inputDatePicker.find('.gfDP_switch a').text(format);
              }
            }
            if (timer.indexOf('m') !== -1) {
              if (!isNaN(parseInt(timer))) {
                dailyDate.minute = parseInt(timer);
              }
            }
          }
        }
        $inputDatePicker.find('.hour').attr('value', dailyDate.hour).val(dailyDate.hour).trigger('value-change');
        $inputDatePicker.find('.minute').attr('value', dailyDate.minute).val(dailyDate.minute).trigger('value-change');
      });

      $inputDatePicker
        .find('.gfDP_switch a')
        .off('click.switch')
        .on('click.switch', function () {
          // format 12 to 24
          if (format == 'AM') {
            format = 'PM';
            if (dailyDate.hour == 0) {
              dailyDate.hour = 12;
            }
            if (dailyDate.hour > 0 && dailyDate.hour <= 11) {
              dailyDate.hour = dailyDate.hour + 12;
            }
          } else {
            format = 'AM';
            if (dailyDate.hour == 12) {
              dailyDate.hour = 0;
            }
            if (dailyDate.hour > 11 && dailyDate.hour <= 23) {
              dailyDate.hour = dailyDate.hour - 12;
            }
          }

          $inputDatePicker.find('.gfDP_switch a').text(format);

          const dformat = dailyDate.hour + 'h, ' + dailyDate.minute + 'm, ' + dailyDate.second + 's';
          $element.attr('value', dformat).val(dformat).trigger('input-change');
        });
    };

    this.refreshCookie = function () {
      // Refesh Cookie
      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      const $targetElement = $gryffBody.find('#' + merId);
      const moduleId = $targetElement.data('gfmodule').getModuleId();

      let oldCookieTime = '';
      const newCookieTime = Date.now();
      if ($gfLeftSideBar.find('#dateEvergreenCookie').length > 0) {
        oldCookieTime = $gfLeftSideBar.find('#dateEvergreenCookie').attr('value');
        const key = 'gp-evergreen-' + moduleId + oldCookieTime;
        const keyDone = 'd-gp-evergreen-' + moduleId + oldCookieTime;
        document.cookie = key + '=; expires=Thu, 18 Dec 2016 12:00:00 UTC; path=/';
        document.cookie = keyDone + '=; expires=Thu, 18 Dec 2016 12:00:00 UTC; path=/';
        $gfLeftSideBar.find('#dateEvergreenCookie').attr('value', newCookieTime).val(newCookieTime);
      }
    };

    function getDefaultValueEvergreen() {
      return {
        day: 0,
        hour: 3,
        minute: 0,
        second: 0,
      };
    }

    this.dateEvergreen = function () {
      let dailyDate = getDefaultValueEvergreen();
      // 12h, 35m, 20s
      let time = $element.attr('value');
      if (time && time != '') {
        let array = ['1'];
        time = time.toString();
        time = time.toLowerCase();
        if (time.indexOf(',') !== -1) {
          array = time.split(',');
        } else {
          array = [time];
        }
        for (let i = 0; i < array.length; i++) {
          const timer = array[i].trim();
          if (timer.indexOf('d') !== -1) {
            if (!isNaN(parseInt(timer))) {
              dailyDate.day = parseInt(timer);
            }
          }
          if (timer.indexOf('h') !== -1) {
            if (!isNaN(parseInt(timer))) {
              dailyDate.hour = parseInt(timer);
            }
          }
          if (timer.indexOf('m') !== -1) {
            if (!isNaN(parseInt(timer))) {
              dailyDate.minute = parseInt(timer);
            }
          }
          if (timer.indexOf('s') !== -1) {
            if (!isNaN(parseInt(timer))) {
              dailyDate.second = parseInt(timer);
            }
          }
        }
      }
      const description =
        typeof $element.attr('data-description') !== 'undefined' ? $element.attr('data-description') : '';
      let _template = '<div class="gfDatePicker" data-type="evergreen">';
      _template += '<div class="gfDP_input"><span>Days</span><input class="day" value="' + dailyDate.day + '" /></div>';
      _template +=
        '<div class="gfDP_input"><span>Hours</span><input class="hour" value="' + dailyDate.hour + '" /></div>';
      _template +=
        '<div class="gfDP_input"><span>Mins</span><input class="minute" value="' + dailyDate.minute + '" /></div>';
      _template += '<a class="gfDatePickerReset">' + utils.svgIcon('reset') + ' Reset Countdown</a>';
      _template += '<div class="gfDesc">' + description + '</div>';
      _template += '</div>';
      const $inputDatePicker = jQuery(_template);
      $element.after($inputDatePicker);

      $inputDatePicker.find('.gfDP_input input').gfInputField({
        addHistory: false,
        delayTyping: 300,
        onValueChanged: function () {
          const $minute = $inputDatePicker.find('.minute');
          const minute = parseInt($minute.attr('value'));

          const $hour = $inputDatePicker.find('.hour');
          const hour = parseInt($hour.attr('value'));

          const $day = $inputDatePicker.find('.day');
          const day = parseInt($day.attr('value'));

          dailyDate = smartEvergreen(day, hour, minute, dailyDate);

          $minute
            .attr('value', dailyDate.minute)
            .val(dailyDate.minute)
            .trigger('value-change')
            .next()
            .find('.gfInputFieldBox>input')
            .val(dailyDate.minute);
          $hour
            .attr('value', dailyDate.hour)
            .val(dailyDate.hour)
            .trigger('value-change')
            .next()
            .find('.gfInputFieldBox>input')
            .val(dailyDate.hour);
          $day
            .attr('value', dailyDate.day)
            .val(dailyDate.day)
            .trigger('value-change')
            .next()
            .find('.gfInputFieldBox>input')
            .val(dailyDate.day);

          // Refesh Cookie
          _this.refreshCookie();

          const dformat =
            dailyDate.day + 'd, ' + dailyDate.hour + 'h, ' + dailyDate.minute + 'm, ' + dailyDate.second + 's';
          $element.attr('value', dformat).val(dformat).trigger('input-change');
        },
        onHistoryAdded: function () {
          $element.trigger('history-change');
        },
      });
      $element.on('value-change', function () {
        // Refesh Cookie
        _this.refreshCookie();

        let time = $element.attr('value');
        if (time && time != '') {
          let array = ['1'];
          time = time.toString();
          time = time.toLowerCase();
          if (time.indexOf(',') !== -1) {
            array = time.split(',');
          } else {
            array = [time];
          }
          const has = {
            day: false,
            hour: false,
            minute: false,
          };
          for (let i = 0; i < array.length; i++) {
            const timer = array[i].trim();
            if (timer.indexOf('d') !== -1) {
              if (!isNaN(parseInt(timer))) {
                dailyDate.day = parseInt(timer);
                has.day = true;
              }
            }
            if (timer.indexOf('h') !== -1) {
              if (!isNaN(parseInt(timer))) {
                dailyDate.hour = parseInt(timer);
                has.hour = true;
              }
            }
            if (timer.indexOf('m') !== -1) {
              if (!isNaN(parseInt(timer))) {
                dailyDate.minute = parseInt(timer);
                has.minute = true;
              }
            }
          }
          const defaultValue = getDefaultValueEvergreen();
          Object.keys(has).forEach((key) => {
            if (!has[key]) {
              dailyDate[key] = defaultValue[key];
            }
          });
        }
        $inputDatePicker.find('.day').attr('value', dailyDate.day).val(dailyDate.day).trigger('value-change');
        $inputDatePicker.find('.hour').attr('value', dailyDate.hour).val(dailyDate.hour).trigger('value-change');
        $inputDatePicker.find('.minute').attr('value', dailyDate.minute).val(dailyDate.minute).trigger('value-change');
      });
      let isReset = false;
      $inputDatePicker
        .find('.gfDatePickerReset')
        .off('click.reset')
        .on('click.reset', function () {
          const $that = jQuery(this);
          if (!isReset) {
            isReset = true;

            // Refesh Cookie
            _this.refreshCookie();
            $element.trigger('input-change');
            $that.html('<span></span>');
            setTimeout(function () {
              $that.html(utils.svgIcon('reset') + ' Reset Countdown');
              isReset = false;
            }, 800);
          }
        });
    };

    this.init();
  };
  jQuery.fn.gfDatePicker = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfdatepicker')) {
        const plugin = new jQuery.gfDatePicker(this, options);
        jQuery(this).data('gfdatepicker', plugin);
      }
    });
  };
})(jQuery);
